import angular from 'angular';

import CalendarListModule from './calendar-list';
import TeamListModule from './team-list';

export default angular
    .module('application.scene.authorized.scene.calendar.component.calendar-navigation.component', [
        CalendarListModule.name,
        TeamListModule.name
    ]);



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/calendar/component/calendar-navigation/component/index.js